import * as t from "io-ts";
import { cargoTypeT } from "../types";
export const cargoTypesT = t.strict({
    cargoTypes: t.array(cargoTypeT),
});
//# sourceMappingURL=cargo-types.js.map